import {
  USER_NOT_AUTHENTICATED_LABEL,
  ACCEDI_LABEL,
  REQUIRED_FIELD,
  NOME_PLACEHOLDER,
  COGNOME_PLACEHOLDER,
  CF_PLACEHOLDER,
  EMAIL_LABEL,
  EMAIL_PLACEHOLDER,
  EMAIL_ERROR,
  CELLULARE_LABEL,
  CELLULARE_PLACEHOLDER,
  CELLULARE_ERROR,
  CELLULARE_ERROR_LENGTH,
  ISTITUTO_LABEL,
  ISTITUTO_PLACEHOLDER,
  INCARICO_LABEL,
  INCARICO_PLACEHOLDER,
  TOOLTIP_DICHIARAZIONE,
  BUTTON_DICHIARAZIONE,
  AUTOCERTIFICAZIONE_PLACEHOLDER,
  PRIVACY_PLACEHOLDER,
  NEWSLETTER_PLACEHOLDER,
  CAMPI_OBBLIGATORI_LABEL,
  SALVA,
  CHIUDI,
  ACCETTA,
  CANCELLA,
  NO_DATA,
  INSRIMENTO_FAILED,
  INSRIMENTO_FAILED_HELP,
  GATEWAY_ERROR_INFO,
  GATEWAY_ERROR_INSTRUCTIONS,
  GATEWAY_ERROR_HELP,
  AVVISO_UTENTE_DISABILITATO,
} from "../modules/language";

const userNotAuthenticated = {
  [USER_NOT_AUTHENTICATED_LABEL]: "Attenzione! Dopo {durata} minuti di inattività la sessione scade automaticamente.",
  [ACCEDI_LABEL]: "Accedi",
};

const formRegistrazione = {
  [REQUIRED_FIELD]: "Campo obbligatorio",
  [NOME_PLACEHOLDER]: "Nome",
  [COGNOME_PLACEHOLDER]: "Cognome",
  [CF_PLACEHOLDER]: "Codice fiscale",
  [EMAIL_LABEL]: "email",
  [EMAIL_PLACEHOLDER]: "Inserisci email",
  [EMAIL_ERROR]: "Formato email non valido",
  [CELLULARE_LABEL]: "Cellulare",
  [CELLULARE_PLACEHOLDER]: "Inserisci numero di cellulare",
  [CELLULARE_ERROR]: "Numero di cellulare non valido",
  [CELLULARE_ERROR_LENGTH]: "Il numero di cellulare deve essere di 10 cifre",
  [ISTITUTO_LABEL]: "Istituto",
  [ISTITUTO_PLACEHOLDER]: "Inserisci istituto",
  [INCARICO_LABEL]: "Ruolo scolastico",
  [INCARICO_PLACEHOLDER]: "Inserisci ruolo scolastico",
  [TOOLTIP_DICHIARAZIONE]: "Per accettare leggi la dichiarazione",
  [BUTTON_DICHIARAZIONE]: "Leggi la dichiarazione",
  [AUTOCERTIFICAZIONE_PLACEHOLDER]: "Autocertificazione - dichiarazione sostitutiva",
  [PRIVACY_PLACEHOLDER]: "Privacy GDPR",
  [NEWSLETTER_PLACEHOLDER]: "Iscrizione a newsletter",
  [CAMPI_OBBLIGATORI_LABEL]: "* Campi obbligatori",
  [SALVA]: "Salva e avanti",
  [CHIUDI]: "Chiudi",
  [ACCETTA]: "Accetta e chiudi",
  [CANCELLA]: "Cancella",
  [NO_DATA]: "Nessun risultato trovato",
  [AVVISO_UTENTE_DISABILITATO]: "Per il nuovo anno scolastico aggiorna i tuoi dati confermando o modificando la scuola di appartenenza e il ruolo",
};

const inserimentoError = {
  [INSRIMENTO_FAILED]: "L'abilitazione al sistema non è andata a buon fine, riprovare in un secondo momento",
  [INSRIMENTO_FAILED_HELP]: "Per assistenza scrivere una mail a ",
};

const gatewayError = {
  [GATEWAY_ERROR_INFO]: "Si è verificato un errore con il sistema di autenticazione",
  [GATEWAY_ERROR_INSTRUCTIONS]: "Chiudere il browser e riprovare",
  [GATEWAY_ERROR_HELP]: "In caso di persistenza dell'errore contattare l'amministratore",
};

const it = {
  ...userNotAuthenticated,
  ...formRegistrazione,
  ...inserimentoError,
  ...gatewayError,
};

export { it };
